// src/environment.js

export const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

export const stripePublishableKey = process.env.REACT_APP_STRIPE_KEY || "pk_test_51RcPdGGd8yfmOEEK0l9c8eBdLAQCkERmaTRWsk3t7lZAp49AcyYmyXmDld9pKp56eNIQGGJdFaeONkWnOxMHOqSy00c9Ji2AfQ";
